import PayDepositTable from './Table';
import PayModal from "./PayModal";

const Components = {
  PayDepositTable,
  PayModal,
};

export default Components;
